import { render } from "./UserOrders.vue?vue&type=template&id=2e17b475"
import script from "./UserOrders.vue?vue&type=script&lang=js"
export * from "./UserOrders.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/geramyan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__